import React from 'react';

const SecuritySolutions = () => {
  return (
    <div style={styles.container}>
      <h1>Coming Soon</h1>
      <p>Stay tuned for the latest updates from Mosaic Digital Creations.</p>
    </div>
  );
};

const styles = {
  container: {
    textAlign: 'center',
    padding: '50px 20px',
    fontFamily: 'Arial, sans-serif',
    color: '#333',
  }
};

export default SecuritySolutions;